const ruleAction = {
    NEW_RULE : 'new rule',

    REDEPLOY : 'redeploy',

    SAVE : 'save',

    DISCARD : 'discard',

    ACTIVATE : 'activate',

    DEACTIVATE : 'deactivate',

    RULE_SETTINGS : 'rule settings',

    DELETE : 'delete',

    REVIEW : 'review',

    BACKUP : 'backup'

};

angular.module('gw-um-j2js')
    .constant('ruleAction', ruleAction);